import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const FooterItem = ({ title, items, link }) => {
  return (
    <div>
      <h6 className="mb-3">{title}</h6>

      <ul>
        {items.map((item, index) => {
          const label = typeof item === "string" ? item : item.label;
          const external = typeof item === "object" && item.external;
          const href = external
            ? item.href
            : `/${label.toLowerCase().replace(/ /g, "-")}`;

          return (
            <li key={index} className="break-all font-mabry-light text-sm">
              {external ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:underline"
                >
                  {label}
                </a>
              ) : link ? (
                <Link to={href} className="text-white hover:underline">
                  {label}
                </Link>
              ) : (
                label
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

FooterItem.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ).isRequired,
  link: PropTypes.bool,
};

export default FooterItem;
